import { Modal, Paper, Typography } from "@mui/material";



import makeStyles from '@mui/styles/makeStyles';



const INSTRUCTIONS = "SOME TEXT THAT WILKRKE  INSTRUCTIONS"

const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: "30%",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #000",
      borderRadius: 10,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `15%`,
      left: `35%`,
      minHeight:300
    },
    title:{
        fontWeight:500,
        fontSize:18,
        marginBottom:5
    }
  }));


export default function InstructionsModal(props){
  const classes = useStyles();  
    const {open, onClose} = props;  

    return(
    <Modal open={open} onClose={onClose}>
      <Paper className={classes.paper}>
          <Typography className={classes.title}>Instructions:</Typography>
        <Typography>{INSTRUCTIONS}</Typography>
        </Paper>
        </Modal>
    )
}